<span [ngClass]="negativeCurrencyCssClass()">{{currencyValue() | accountingCurrency}}</span>